import {Issue} from '@/models/Issue'
import {Model} from '@/models/Model'
import {DataArray, DataResource, FilterSet} from '@/models/Response'
import Helper from '../services/Helper.js'


export const TruckConst = Object.freeze({
  TYPE_TEST: 20,

  map(type: string): string {
    const map = {
      'VAN': 'รถตู้',
      'ICE-CREAM': 'รถไอติม',
      'SINGLE-HEAD': 'รถกระบะหัวเดี่ยว',
      'CAB': 'รถกระบะมี CAB',
      'SMALL-4WL': 'รถ 4 ล้อเล็ก',
      'MEDIUM-4WL': 'รถ 4 ล้อกลาง',
      'MEDIUM-6WL': 'รถ 6 ล้อ',
      'SERVICE-CAB': 'รถช่าง',
      'CAR': 'รถเก๋ง',
      'TRAY-4WL': 'รถ 4 ล้อ คอก',
      'LARGE-10WL': 'รถ 10 ล้อ',
    }
    return map[type]
  },
})


export class OpcBlock extends Model {
  created_at: Date | null
  updated_at: Date | null
  name: string | null
  block_index: string | null
  shop_no: string | null
  status: string | null
  server: string | null
  auto_assign: boolean | null
  data: any | null
  issue_id: number | null

  getResourceURL(): string {
    return Helper.setting.opc_block.getResourceAPI
  }


}

export class DataTrucksArray extends DataArray {

  declare data: OpcBlock[]
  filter: FilterTruck = new FilterTruck()
}


export class FilterTruck {
  price_group: FilterSet = new FilterSet()
}


export class DataTruck extends DataResource {

  declare data: OpcBlock

}
